exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pop-500 {\n  min-width: 500px;\n  max-width: 700px;\n  max-height: 80vh;\n  overflow: auto;\n}\n\n.dialog-content {\n  padding: 20px;\n  max-height: 60vh;\n  overflow-y: auto;\n}\n\n.message {\n  margin-bottom: 15px;\n  line-height: 1.5;\n}\n\n.counterparties-list {\n  margin-top: 15px;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.filter-list {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\n.filter-list li {\n  padding: 8px 12px;\n  border-bottom: 1px solid #e0e0e0;\n  line-height: 1.5;\n}\n\n.filter-list li:last-child {\n  border-bottom: none;\n}\n\n.filter-list li:hover {\n  background-color: #f5f5f5;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/import/review/filter-counterparties-dialog.component.css
// module id = 1918
// module chunks = 0